
export default {
  props: {
    liked: {type: Boolean, required: true},
    size: {type: String, default: '1.6rem'}
  }
}
